class CPREventEmitter {
    private handlers: { [key: string]: Function[] } = {};

    public subscribe(event: string, handler: Function): () => void {
        if (!this.handlers[event]) {
            this.handlers[event] = [];
        }
        this.handlers[event].push(handler);

        return () => {
            this.handlers[event] = this.handlers[event].filter(h => h !== handler);
        };
    }

    public emit(event: string, value?: string): void {
        if (this.handlers[event]) {
            this.handlers[event].forEach(handler => handler(value));
        }
    }
}

export const EVENTS = {
    START_CPR: 'CPR_STARTED',
    RESET_CPR: 'RESET_CPR',
    OPEN_MEDICATIONS: 'OPEN_MEDICATIONS',
    ADRENALINE_GIVEN: 'ADRENALINE_GIVEN',
    ADD_MEDS_SECTION: 'ADD_MEDS_SECTION'
} as const;

export const cprEventEmitter = new CPREventEmitter();